// extracted by mini-css-extract-plugin
export var article = "content-module--article--23l_n";
export var wpCaptionText = "content-module--wp-caption-text--YEpvG";